// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"7330":"css/app.6766","9902":"css/admin-app.6766"}[chunkId] + ".css";
};